const collapseWhitespace = (value: string): string => value.trim().replace(/\s+/g, ' ');

const titleCaseToken = (token: string): string => {
  if (!token) return '';
  const lower = token.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
};

const titleCaseWord = (word: string): string => {
  if (!word) return '';
  return word
    .split(/([-'])/)
    .map(part => (part === '-' || part === "'" ? part : titleCaseToken(part)))
    .join('');
};

export const ownerKey = (name: string): string => collapseWhitespace(name).toLowerCase();

export const normalizeOwnerDisplayName = (name: string): string => {
  const cleaned = collapseWhitespace(name);
  if (!cleaned) return '';

  // Keep email owners stable and predictable.
  if (cleaned.includes('@')) {
    return cleaned.toLowerCase();
  }

  // Handle specific overrides
  const lowerCleaned = cleaned.toLowerCase();
  if (lowerCleaned === 'matt' || lowerCleaned === 'matt alsford') {
    return 'Matt A';
  }
  if (lowerCleaned === 'will lawson') {
    return 'William Lawson';
  }

  return cleaned
    .split(' ')
    .map(titleCaseWord)
    .join(' ');
};

export const isAssignedOwnerName = (name: string | null | undefined): boolean => {
  const normalized = name ? normalizeOwnerDisplayName(name) : '';
  return Boolean(normalized) && normalized.toLowerCase() !== 'unassigned';
};

export const normalizeOptionalOwnerName = (name?: string | null): string | null => {
  if (!name) return null;
  const normalized = normalizeOwnerDisplayName(name);
  return normalized || null;
};

export const abbreviateOwnerName = (name: string | null | undefined): string => {
  if (!name) return '';
  const normalized = normalizeOwnerDisplayName(name);
  if (normalized.includes('@')) return normalized; // Don't abbreviate emails
  const parts = normalized.trim().split(/\s+/);
  if (parts.length < 2) return parts[0] || '';
  return `${parts[0]} ${parts[parts.length - 1].charAt(0).toUpperCase()}.`;
};

export const dedupeOwnerNamesCaseInsensitive = (names: string[]): string[] => {
  const byKey = new Map<string, string>();
  names.forEach(name => {
    const normalized = normalizeOwnerDisplayName(name);
    const key = ownerKey(normalized);
    if (!key || byKey.has(key)) return;
    byKey.set(key, normalized);
  });

  return Array.from(byKey.values()).sort((a, b) => a.localeCompare(b));
};
